import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const getskeletonStyles = makeStyles({
  row: {
    display: 'flex',
    ...shorthands.gap('8px'),
    flexWrap: 'wrap',
  },
  item: {
    height: '55px',
    width: '55px',
    backgroundColor: tokens.colorNeutralStencil1,
  },
});


export const useStyles = makeStyles({
  displayColorPicker: {
    '& .helpbutton': {
      display: 'inline',
    },
  },
  colorPalette: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.margin(tokens.spacingVerticalM, 0, 0, 0),
  },
  item: {
    height: '55px',
    width: '55px',
    backgroundColor: tokens.colorNeutralStencil1,
  },
  helpButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});
